import { Component, ViewChild } from '@angular/core';
import { DynamicPageComponent } from '../../helpers/dynamicPage';
import { DynamicPageDirective } from '../../directives/index';
import { DynamicPage,User} from '../../models/data.types';

@Component({
  selector: 'app-aside',
  templateUrl: './app-aside.component.html',
  entryComponents: [DynamicPageComponent],
})
export class AppAsideComponent {
  
  @ViewChild(DynamicPageDirective) dynamicPage: DynamicPageDirective;

  constructor(private dynamicPageComponent: DynamicPageComponent) {  }

  ngOnInit() {

    this.dynamicPageComponent.LoadDynamicPage("AppshellSupport",this.dynamicPage,false);
  }
}
  


// WEBPACK FOOTER //
// ./src/app/components/app-aside/app-aside.component.ts